import * as z from "zod";
import { literal } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";

export const CustomerSignInStructuredContentSchema = z.object({
  reason: z.string().optional(),
  customerEmail: z.string().email().optional(),
});

export type CustomerSignInStructuredContent = z.infer<
  typeof CustomerSignInStructuredContentSchema
>;

const CustomerSignInMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CUSTOMER_SIGN_IN_UI),
  structuredContent: CustomerSignInStructuredContentSchema.optional(),
});

export const CustomerSignInMessageDbParser = CustomerSignInMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type CustomerSignInMessageType = z.infer<
  typeof CustomerSignInMessageDbParser
>;
export type CustomerSignInMessageTypeWithoutId =
  WithoutId<CustomerSignInMessageType>;
